export const LOCALE_SE = {
    ORDER: "Beställning",
    INVOICE: "Faktura",
    INVOICES: "Fakturor",
    CREDIT_NOTE: "Kreditnota",
    CREDIT_NOTES: "Kreditnotor",
    CREATION_DATE: "Utfärdandedatum",
    DELIVERY_DATE: "Leveransdatum",
    DELIVERY_ADDRESS: "Leveransadress",
    DELIVERY_COST: "Leveranskostnad",
    VENDOR: "Leverantör",
    CUSTOMER: "Kund",
    ORDER_NUMBER: "Ordernummer",
    PAYMENT_METHOD: "Betalningsmetod",
    NOTE: "Notering",
    PRODUCT: "Produkt",
    PRODUCT_DESCRIPTION: "Beskrivning",
    PRODUCT_AMOUNT: "Antal",
    PRODUCT_SINGLE_PRICE: "Enhetspris",
    DISCOUNT: "Rabatt",
    TOTAL_DISCOUNTS: "Total rabatt",
    TOTAL_BEFORE_DISCOUNTS: "Totalt före rabatt",
    TAX_ABBREVIATED: "Moms",
    TAX_AMOUNT: "Skattebelopp",
    SPLIT_AMOUNT: "Andel",
    BRUTTO: "Brutto",
    TOTAL: "Totalt",
    TOTAL_INCLUDING_VAT: "Totalt inkl. moms",
    TOTAL_EXCLUDING_VAT: "Totalt exkl. moms",
    VAT_ID: "Momsregistreringsnummer",
    TAX_ID: "Skatteregistreringsnummer",
    PAID: "Betald",
    UNPAID_AMOUNT: "Obetalt belopp",
    REASON: "Orsak",
    INVOICE_LINE_ITEMS_TITLE: "Orderposter",
    CREDIT_NOTES_LINE_ITEMS_TITLE: "Kreditnotor på orderposter",
    OTHER_CREDIT_NOTES: "Justering av ordern",
    REFUND_SHIPPING_COST: "Returleveranskostnader",
    REFUND_HAS_BEEN_PAID: "Återbetalning på $VALUE har betalats.",
    REFUND_HAS_BEEN_PAID_FAILED: "Det uppstod ett fel vid återbetalningen på $VALUE.",
    DOCUMENTS_FOR_ORDER: "Dokument för beställningen",
    NO_INVOICES: "Inga fakturor tillgängliga ännu",
    NO_CREDIT_NOTES: "Inga kreditnotor tillgängliga ännu",
    DOCUMENTS_ARE_GENERATING: "Fakturadokument genereras för närvarande. Försök igen om några minuter.",
    INVALID_REQUEST_PATHWAY_SUPPORT: "Inga dokument hittades för denna beställning. Vänligen kontakta support@pathway-solutions.de.",
    INVALID_REQUEST_GENERIC: "Inga dokument hittades för denna beställning. Vänligen kontakta den respektive leverantören.",
    INVALID_REQUEST_INDIVIDUAL_SUPPORT: "Inga dokument hittades för denna beställning. Vänligen kontakta ${MAIL}.",
    GIFT_CARD_LINE: "En presentkortskod ${GIFT_CARD_CODE} på ${GIFT_CARD_AMOUNT} användes för denna beställning.",
    GIFT_CARD: "Presentkort",
    REVERSAL_INVOICE: "Kreditfaktura",
    REVERSAL_CREDIT_NOTE: "Annullering av kreditnota",
    DUTY: "Tullavgift",
    USED_DISCOUNTS: "använda rabatter",
    PAYMENT_AT: "Betalning den $DATE",
    REFUNDED_CREDITNOTE_AT: "Återbetalning av kreditnota $CREDIT_NOTE den $DATE",
    REFUNDED_AT: "Återbetalning den $DATE",
    PROCESSING_DOCUMENT: "Dokument bearbetas",
    DOWNLOAD_DOCUMENTS_TITLE: "Ladda ner dina dokument här!",
    MAIL_INTRODUCTION: "Vid frågor, vänligen kontakta ${MAIL}",
    REPAYMENT_DIFFERENCE: "Återbetalningsdifferens",
    DOCUMENT_PREVIEW_BANNER: "Förhandsvisning – ladda ner PDF",
};
